<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  
mounted() {
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
},
  methods: {
    beforeunloadHandler(e) {
      //  localStorage.setItem("current", 0);
    }
},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // location.reload();
    if (document.documentElement.clientWidth <= 800) {
      // window.location.href='https://www.baidu.com'
    }
  },
  destroyed() {
    
  },
};
</script>
<style lang="less">
// 超链接
a {
  text-decoration: none;
}

//列表
ul {
  list-style-type: none;
}
// 轮播点
.el-carousel__indicator--horizontal {
  // padding: 40px 4px !important;
}
.el-carousel__indicators--outside button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
// 小屏幕
@media (max-width: 1279px) {
  // 公共块的样式
  .card {
    width: 900px;
    margin-left: 50%;
    transform: translateX(-50%);
  }
  .all_text {
    .text {
      font-size: 22px !important;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 40px !important;
      padding: 30px 0 32px 0 !important;
    }
  }
}
// 中屏幕
@media screen and (max-width: 1600px) and (min-width: 1280px) {
  // 公共块的样式
  .card {
    width: 1100px;
    margin-left: 50%;
    transform: translateX(-50%);
    //  background: green;
  }
}

/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media (min-width: 1600px) {
  // 公共块的样式
  .card {
    width: 1300px;
    margin-left: 50%;
    transform: translateX(-50%);
    // background: red;
  }
}
// 文字
.all_text {
  .text {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    line-height: 49px;
    padding: 46px 0 32px 0;
  }

  .row {
    height: 1px;
    width: 50px;
    border-bottom: 2px dashed #fe9f3a;
  }
}

.some_info {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 27px;
  opacity: 0.8;
  width: 388px;
  padding: 40px 0;
}
.banner {
  cursor: pointer;
}
</style>
